<asax-header-search-input-info [searchInput]="searchInput"
                               (outExampleClick)="onExampleClick($event)">
  <content *ngTemplateOutlet="content"></content>
</asax-header-search-input-info>
<ng-template #content>
  <div class="text-nowrap">
    <label id="{{'header-filter-label-' + searchInput.id}}"
           for="{{'header-filter-' + searchInput.id}}"
           class="form-label mb-0 me-1">{{searchInput.label}}
    </label>
    <i *ngIf="searchInput.isDisabled"
       class="fa-light fa-eye-slash me-1"
       placement="right"
       ngbTooltip="Filter is disabled">
    </i>
  </div>
  <div class="input-group input-group-sm has-validation"
       [ngbTooltip]="suggestionsListLoadingContent"
       #tooltip="ngbTooltip"
       triggers="manual"
       placement="bottom">
    <input id="{{'header-filter-' + searchInput.id}}"
           class="form-control"
           #typeahead=ngbTypeahead
           [ngbTypeahead]="search"
           [class.is-invalid]="searchInput.value?.length > 0 && isInvalid === true"
           [class.is-valid]="searchInput.value?.length > 0 && isInvalid === false"
           [(ngModel)]="searchInput.value"
           (ngModelChange)="valueChangedWithDebounceTime()"
           [ngbTooltip]="searchInput.tooltip"
           triggers="focusin:keydown"
           placement="bottom"
           [disableTooltip]="!searchInput.tooltip"/>
    <button *ngIf="searchInput.value?.length > 0"
            class="btn btn-light border-dark"
            type="button"
            (click)="clearSearchInputValue()">
      <i class="fa-light fa-xmark"></i>
    </button>
    <div class="invalid-tooltip">
      <i class="fa-light fa-circle-exclamation me-1"></i>{{errorMessage}}
    </div>
  </div>
</ng-template>

<ng-template #suggestionsListLoadingContent>
  <div class="spinner-border spinner-border-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
  loading {{searchInput.label | lowercase}} suggestions ...
</ng-template>

